import { Link } from "react-router-dom";

const TERMS = [
  ["Best Point Savings & Loans", "/entities/best-point"], ["Despite Automobile Museum", "/entities/despite-automobile-museum"],
  ["Golden Crest Hotel", "/entities/golden-crest-hotel"], ["Peacefmonline.com", "/entities/peacefmonline"],
  ["Despite Stores", "/entities/despite-stores"], ["Best Assurance", "/entities/best-assurance"], ["Best Pensions", "/entities/best-pensions"],
  ["Atona Foods", "/entities/atona-foods"], ["Neat Foods", "/entities/neat-foods"], ["Special Ice", "/entities/special-ice"],
  ["Best Point", "/entities/best-point"], ["This Way", "/entities/atona-foods"], ["U2 Salt", "/entities/u2-salt"],
  ["Peace FM", "/entities/peace-fm"], ["Okay FM", "/entities/okay-fm"], ["Neat FM", "/entities/neat-fm"], ["Hello FM", "/entities/hello-fm"],
  ["UTV", "/entities/utv"], ["Dr. Ernest Ofori Sarpong", "/people/ernest-ofori-sarpong"], ["Dr. Ofori Sarpong", "/people/ernest-ofori-sarpong"],
  ["Dr. Osei Kwame Despite", "/people/osei-kwame-despite"], ["Dr. Despite", "/people/osei-kwame-despite"], ["Kennedy Osei", "/people/kennedy-osei"],
];
const MAP = Object.fromEntries(TERMS);
const RE = new RegExp(`(${TERMS.map(([t]) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})`, "g");

export const Linkify = ({ text, light }) =>
  text.split(RE).map((part, i) =>
    MAP[part] ? (
      <Link key={i} to={MAP[part]} className={`font-semibold underline decoration-[color:var(--gold-hi)] decoration-2 underline-offset-2 ${light ? "text-white hover:text-[color:var(--gold-hi)]" : "text-brand-green hover:text-[color:var(--gold)]"}`} data-testid={`inline-link-${MAP[part].split("/").pop()}`}>{part}</Link>
    ) : part
  );
